<template>
  <div class="weekday-selector">
    <v-chip-group
      :value="selectedWeekday"
      class="weekday-selector__group"
      mandatory
      @change="handleChange"
    >
      <v-chip
        v-for="tab in weekdayTabs"
        :key="tab.value"
        :value="tab.value"
        :class="{
          'primary': selectedWeekday === tab.value,
          'bg-secondary primary--text': selectedWeekday !== tab.value,
        }"
        class="rounded-0 ma-0 w-100"
      >
        {{ t(tab.name, options) }}
      </v-chip>
    </v-chip-group>
  </div>
</template>

<script setup lang="ts">
import { toRefs } from 'vue'
import I18NextVue from 'i18next'
import { format } from 'date-fns'
import type { Filters } from 'www/vue_components/common/TheFilters/lpu/stores/useFiltersStore.types'

type Weekday = Extract<Filters['timeWork'], { type: 'custom' }>['weekday']

const emit = defineEmits(['input'])
const props = withDefaults(defineProps<{
  value?: Weekday,
}>(), {
  // По умолчанию - текущий день недели
  value: format(new Date(), 'EEEE').toLowerCase() as Weekday,
})
const { value: selectedWeekday } = toRefs(props)

const { t, language } = I18NextVue
const options = { ns: language }

const weekdayTabs: Array<{ name: string, value: Weekday }> = [
  { name: 'Пн', value: 'monday' },
  { name: 'Вт', value: 'tuesday' },
  { name: 'Ср', value: 'wednesday' },
  { name: 'Чт', value: 'thursday' },
  { name: 'Пт', value: 'friday' },
  { name: 'Сб', value: 'saturday' },
  { name: 'Вс', value: 'sunday' },
]

const handleChange = (weekday: Weekday) => {
  emit('input', weekday)
}
</script>

<style lang="scss" scoped>
@import '~www/themes/doctors/common/variables';

.weekday-selector {
  display: flex;

  :deep(.v-slide-group__content) {
    padding: 0;
  }

  :deep(.v-chip:not(:last-child)) {
    border-right: 2px solid $ui-kit-bg-gray-60 !important;
  }

  &__group {
    width: 100%;
    border-radius: 9999px;
    display: inline-flex;
    overflow: hidden;
  }
}
</style>
